import { InfoBarMessageRank } from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * get infoBar icon based on rank
 */
const getInfoBarIcon = (rank: InfoBarMessageRank) => {
    switch (rank) {
        case InfoBarMessageRank.SmimeSignature:
            return ControlIcons.Ribbon;
        case InfoBarMessageRank.Encryption:
            return isFeatureEnabled('cmp-clp') ? ControlIcons.Lock : ControlIcons.Encryption;
        case InfoBarMessageRank.Error:
            return ControlIcons.ErrorBadge;
        case InfoBarMessageRank.Translation:
            return ControlIcons.MicrosoftTranslatorLogo;
        case InfoBarMessageRank.Sensitivity:
            return ControlIcons.MarkAsProtected;
        default:
            return ControlIcons.Info;
    }
};

export default getInfoBarIcon;
